import React, { useMemo } from 'react';

interface Snowflake {
  id: number;
  left: number;
  size: number;
  opacity: number;
  duration: number;
  delay: number;
}

const Snowfall: React.FC = () => {
  const snowflakes = useMemo<Snowflake[]>(() => {
    return Array.from({ length: 35 }, (_, i) => ({
      id: i,
      left: Math.random() * 100,
      size: 4 + Math.random() * 8,
      opacity: 0.3 + Math.random() * 0.5,
      duration: 8 + Math.random() * 7,
      delay: Math.random() * 5,
    }));
  }, []);

  return (
    <div className="fixed inset-0 pointer-events-none z-40 overflow-hidden">
      {snowflakes.map((flake) => (
        <div
          key={flake.id}
          className="absolute animate-snowfall"
          style={{
            left: `${flake.left}%`,
            width: `${flake.size}px`,
            height: `${flake.size}px`,
            opacity: flake.opacity,
            animationDuration: `${flake.duration}s`,
            animationDelay: `${flake.delay}s`,
          }}
        >
          <div 
            className="w-full h-full rounded-full bg-white"
            style={{
              boxShadow: '0 0 4px rgba(255, 255, 255, 0.8)',
            }}
          />
        </div>
      ))}
    </div>
  );
};

export default Snowfall;
